import { render } from "./attempt-view.vue?vue&type=template&id=6f4b319d"
import script from "./attempt-view.vue?vue&type=script&lang=js"
export * from "./attempt-view.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__